// @flow
import * as React from 'react';
import classNames from 'classnames';
import Box from 'sail/Box';
import Toggle, {ToggleItem} from 'sail/Toggle';
import Select from 'sail/Select';
import {BodyAlt} from 'sail/Text';

import {formatLanguage} from 'docs/interactive/IntegrationBuilder/util';
import {usePrefs} from 'docs/data';
import {useFile, useStep} from 'docs/data/integration-builder';
import type {
  Server,
  Client,
  Platform,
  Reader,
  TerminalCountry,
  SettingValue,
} from 'docs/data/integration-builder';

import './Setting.scss';

type SettingProps = {|
  label: string | React.Node,
  pref: string,
  items:
    | Array<Server>
    | Array<Client>
    | Array<Platform>
    | Array<Reader>
    | Array<TerminalCountry>,
  activeItem: SettingValue,
  getExtraPrefs?: (string) => {[string]: string},
|};

export const Setting = ({
  label,
  pref,
  activeItem,
  items,
  getExtraPrefs,
}: SettingProps) => {
  const {setPrefs} = usePrefs();
  const {setActiveFile} = useFile();
  const {setActiveStep} = useStep();
  return (
    <Box flex={{alignItems: 'center'}} className="Setting">
      <BodyAlt color="dark" style={{marginRight: 12}}>
        {label}
      </BodyAlt>
      <Box className={classNames('Setting--full')}>
        <Toggle name={pref} type="radio">
          {items.map((item) => {
            return (
              <ToggleItem
                key={item}
                label={formatLanguage(item)}
                checked={item === activeItem}
                onChange={() => {
                  setActiveFile('');
                  setActiveStep('');
                  let extraPrefs = {};
                  if (getExtraPrefs) {
                    extraPrefs = getExtraPrefs(item);
                  }
                  setPrefs({[pref]: item, ...extraPrefs});
                }}
              />
            );
          })}
        </Toggle>
      </Box>
      <Box className={classNames('Setting--small')}>
        <Select
          value={activeItem}
          options={items.map((item) => {
            return {
              label: formatLanguage(item),
              value: item,
            };
          })}
          onChange={(item) => {
            setActiveFile('');
            let extraPrefs = {};
            if (getExtraPrefs) {
              extraPrefs = getExtraPrefs(item);
            }
            setPrefs({[pref]: item, ...extraPrefs});
          }}
        />
      </Box>
    </Box>
  );
};
